import axios from 'axios';

export const gastosReportApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND!}api`,
  headers: { "Content-Type": "application/json" },
});